import { render } from "./AccountHelp.vue?vue&type=template&id=91f78484&scoped=true"
import script from "./AccountHelp.vue?vue&type=script&lang=js"
export * from "./AccountHelp.vue?vue&type=script&lang=js"

import "./AccountHelp.vue?vue&type=style&index=0&id=91f78484&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\lms-alternates\\vue-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91f78484"]])

export default __exports__